import { GridInput } from '../grid';
import { DecimalValue } from '../decimal';
import { ReceivedFileInterface as File } from '../../types/FileInterface';

export interface Claim {
    id?: number;
    /** Skladon claim number (Full Claim Number) assigned when the claim is created. */
    fcn?: string;
    eshopClaimId: string;
    eshopOrderId: string;
    claimCause: string;
    causeOtherType: string | null;
    description: string;
    note: string | null;
    createdAt: string | null;
    updatedAt: string | null;
    closedAt: string | null;
    status: string | null;
    resolutionText: string | null;
    resolver: string | null;
    transportPrice: DecimalValue | null;
    goodsPrice: DecimalValue | null;
    totalServicePrice: DecimalValue | null;
    compensationCurrency: string | null;
    /** Whether camera footage of the packing process was requested for this claim. */
    cctv?: boolean;
    inProcessAt?: string | null;
    moreInfoNeededAt?: string | null;
    informationAddedAt?: string | null;
    rejectedAt?: string | null;
    canceledAt?: string | null;
    acceptedExpectCompensationAt?: string | null;
    acceptedPendingClientCompensationAt?: string | null;
    /** Internal ID of the claimed order — only returned by the grid endpoint. */
    orderId?: number | null;
    /** Order type of the claimed order — only returned by the grid endpoint. */
    orderType?: string | null;
    /** Carrier of the claimed order — only returned by the grid endpoint. */
    shipper?: string | null;
    /** Tracking number of the claimed order — only returned by the grid endpoint. */
    trackingNumber?: string | null;
    /** Return tracking number of the claimed order — only returned by the grid endpoint. */
    returnTrackingNumber?: string | null;
    files?: File[];
    products?: ClaimProduct[];
    eshopNote?: string | null;
}

export interface ClaimProduct {
    sku: string;
    lineState: string;
    resendQuantity: number | null;
    claimedQuantity: number;
}

export const toCoreClaimNames = {
    id: 'ID',
    fcn: 'FCN',
    eshopClaimId: 'ESHOP_CLAIM_ID',
    eshopOrderId: 'ESHOP_ORDER_ID',
    orderId: 'ORDER_ID',
    orderType: 'ORDER_TYPE',
    shipper: 'SHIPPER',
    trackingNumber: 'TRACKING_NUMBER',
    returnTrackingNumber: 'RETURN_TRACKING_NUMBER',
    cctv: 'CCTV',
    description: 'DESCRIPTION',
    note: 'NOTE',
    claimCause: 'CLAIM_CAUSE',
    causeOtherType: 'CLAIM_CAUSE_OTHERS_TYPE',
    status: 'STATUS',
    createdAt: 'CREATED_AT',
    updatedAt: 'UPDATED_AT',
    closedAt: 'CLOSED_AT',
    inProcessAt: 'IN_PROCESS_AT',
    moreInfoNeededAt: 'MORE_INFO_NEEDED_AT',
    informationAddedAt: 'INFORMATION_ADDED_AT',
    rejectedAt: 'REJECTED_AT',
    canceledAt: 'CANCELED_AT',
    acceptedExpectCompensationAt: 'ACCEPTED_EXPECT_COMPENSATION_AT',
    acceptedPendingClientCompensationAt: 'ACCEPTED_PENDING_CLIENT_COMPENSATION_AT',
    resolutionText: 'RESOLUTION_TEXT',
    resolver: 'RESOLVER',
    transportPrice: 'TRANSPORT_PRICE',
    goodsPrice: 'GOODS_PRICE',
    totalServicePrice: 'TOTAL_SERVICE_PRICE',
    compensationCurrency: 'COMPENSATION_CURRENCY',
    eshopNote: 'ESHOP_NOTE',
};

export const fromCoreClaimNames = {
    ID: 'id',
    FCN: 'fcn',
    ESHOP_CLAIM_ID: 'eshopClaimId',
    ESHOP_ORDER_ID: 'eshopOrderId',
    ORDER_ID: 'orderId',
    ORDER_TYPE: 'orderType',
    SHIPPER: 'shipper',
    TRACKING_NUMBER: 'trackingNumber',
    RETURN_TRACKING_NUMBER: 'returnTrackingNumber',
    CCTV: 'cctv',
    DESCRIPTION: 'description',
    NOTE: 'note',
    CLAIM_CAUSE: 'claimCause',
    CLAIM_CAUSE_OTHERS_TYPE: 'causeOtherType',
    STATUS: 'status',
    CREATED_AT: 'createdAt',
    UPDATED_AT: 'updatedAt',
    CLOSED_AT: 'closedAt',
    IN_PROCESS_AT: 'inProcessAt',
    MORE_INFO_NEEDED_AT: 'moreInfoNeededAt',
    INFORMATION_ADDED_AT: 'informationAddedAt',
    REJECTED_AT: 'rejectedAt',
    CANCELED_AT: 'canceledAt',
    ACCEPTED_EXPECT_COMPENSATION_AT: 'acceptedExpectCompensationAt',
    ACCEPTED_PENDING_CLIENT_COMPENSATION_AT: 'acceptedPendingClientCompensationAt',
    RESOLUTION_TEXT: 'resolutionText',
    RESOLVER: 'resolver',
    TRANSPORT_PRICE: 'transportPrice',
    GOODS_PRICE: 'goodsPrice',
    TOTAL_SERVICE_PRICE: 'totalServicePrice',
    COMPENSATION_CURRENCY: 'compensationCurrency',
    ESHOP_NOTE: 'eshopNote',
};
